import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

const SingleVideoPlayer = React.memo(function SingleVideoPlayer() {
    const { videoId } = useParams();
    const videoUrl = `/videos/${videoId}.mp4`;
    const videoRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [overlay, setOverlay] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        setOverlay(true);
        if (videoRef.current) {
            videoRef.current.muted = true;

            const videoElement = videoRef.current;
            const handleLoadedData = () => {
                setIsLoading(false);
            };

            videoElement.addEventListener('loadeddata', handleLoadedData);

            videoElement.load();

            return () => {
                videoElement.removeEventListener('loadeddata', handleLoadedData);
            };
        }
    }, [videoUrl]);

    const handleUnmute = () => {
        if (videoRef.current) {
            videoRef.current.muted = false;
            setOverlay(false);
            if (videoRef.current.paused) {
                videoRef.current.play().catch(error => console.error("Error attempting to play video:", error));
            }
        }
    };

    return (
        <div style={{ textAlign: "center", marginTop: 40, position: "relative" }}>
            <div
                className="video-hover-container"
                style={{ display: "inline-block", position: "relative", minWidth: '320px', minHeight: '180px' }}
            >
                { }
                {isLoading && (
                    <Box
                        style={{
                            width: "100%",
                            maxWidth: "850px",
                            height: "480px",
                            borderRadius: "12px",
                            background: "#000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            zIndex: 1,
                        }}
                    >
                        <CircularProgress
                            size={80}
                            style={{ color: "#fff" }}
                        />
                    </Box>
                )}

                <video
                    ref={videoRef}
                    src={videoUrl}
                    controls
                    autoPlay
                    playsInline
                    style={{
                        width: "100%",
                        maxWidth: "850px",
                        maxHeight: "850px",
                        borderRadius: "12px",
                        cursor: overlay ? "pointer" : "default",
                        background: "#000",
                        outline: "none",
                        display: "block",
                        visibility: isLoading ? "hidden" : "visible",
                    }}
                    tabIndex={0}
                    onClick={overlay ? handleUnmute : undefined}
                    className="custom-video"
                />

                {!isLoading && overlay && (
                    <div
                        onClick={handleUnmute}
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            background: "rgba(0,0,0,0.35)",
                            borderRadius: "12px",
                            fontSize: "2rem",
                            fontWeight: "bold",
                            cursor: "pointer",
                            zIndex: 2,
                            userSelect: "none",
                        }}
                    >
                        🔇 Tap To Unmute
                    </div>
                )}

                <style>{`
          .video-hover-container video::-webkit-media-controls {
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.2s;
          }
          .video-hover-container:hover video::-webkit-media-controls {
            opacity: 1;
            pointer-events: auto;
          }
          .video-hover-container video::-moz-media-controls {
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.2s;
          }
          .video-hover-container:hover video::-moz-media-controls {
            opacity: 1;
            pointer-events: auto;
          }
        `}</style>
            </div>
        </div>
    );
});

export default SingleVideoPlayer;
